module.exports = __webpack_public_path__ + "static/media/searchicon.6a653f5d.webp";